import { render, staticRenderFns } from "./ChatAgent.vue?vue&type=template&id=f43ef49c&scoped=true&"
import script from "./ChatAgent.vue?vue&type=script&lang=js&"
export * from "./ChatAgent.vue?vue&type=script&lang=js&"
import style0 from "./ChatAgent.vue?vue&type=style&index=0&id=f43ef49c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43ef49c",
  null
  
)

export default component.exports